import { useEffect, useState } from "react";
import "./RechargeSlab.scss";
import { getRechargeSlab } from "../../../../service/Account/Account";
import RechargeSlabIcon from "../../../../utils/Images/RechargeSlabIcon";
import { useTranslation } from "react-i18next";
import { getSessionStorageItem } from "../../../../utils/SessionStorageMethod/getSessionStorageItem";
const RechargeSlab = ({ rechargeSlabId, setRechargeSlabId }: any) => {
  const [rechargeSlab, SetRechargeSlab] = useState<any>([]);
  const freePlanUsed = getSessionStorageItem("freePlanUsed");
  const { t } = useTranslation();
  useEffect(() => {
    getSlab();
  }, []);
  const getSlab = async () => {
    const slabData = await getRechargeSlab(
      process.env.REACT_APP_CURRENCY_ID || "",
    );
    if (slabData?.length) {
      SetRechargeSlab(slabData);
    }
  };
  return (
    <div className="rechargeSlab">
      {rechargeSlab?.map((item: any, index: number) => {
        return (
          <div
            onClick={() => {
              if (index !== 0) {
                setRechargeSlabId(item);
              }
            }}
            key={index}
            className={`creditContent brCyan ${rechargeSlabId?.rechargeSlabId === item.rechargeSlabId ? "slabActive" : ""}`}
          >
            {index === 0 ? (
              <>
                <div>
                  <RechargeSlabIcon
                    color={index === 0 ? "#b3b3b3" : "#2EBEC6"}
                  />
                  <span>Free</span>
                </div>
                <div>
                  <h6>
                    {item?.credits + item?.extraCredits} {t("PAYMENT.CREDITS")}
                  </h6>
                  <p>
                    {item?.extraCredits === 0 ? (
                      freePlanUsed ? (
                        t("PAYMENT.CREDIT_EXHAUSTED")
                      ) : (
                        ""
                      )
                    ) : (
                      <>
                        {t("PAYMENT.EXTRA")}{" "}
                        {(item?.extraCredits / item?.credits) * 100}
                      </>
                    )}
                  </p>
                </div>
              </>
            ) : (
              <>
                {" "}
                <div>
                  <RechargeSlabIcon
                    color={index === 0 ? "#b3b3b3" : "#2EBEC6"}
                  />
                  <span className="unBld">$</span>
                  <span>{item?.amount}</span>
                </div>
                <div>
                  <h6>
                    {item?.credits + item?.extraCredits} {t("PAYMENT.CREDITS")}
                  </h6>
                  <p>
                    {item?.extraCredits === 0 ? null : (
                      <>
                        {t("PAYMENT.EXTRA")}{" "}
                        {(item?.extraCredits / item?.credits) * 100}%
                      </>
                    )}
                  </p>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RechargeSlab;
